import { useTranslate } from "ra-core";

import { ActivityLog } from "../activity/ActivityLog";
import { morphTriggerSelector } from "./closeButtonPlacement";
import { useMobileChrome } from "./MobileChrome";
import { MorphWindow } from "./MorphWindow";

/** Latest activity, a full-screen window grown from the top-bar bell. */
export const NotificationsWindow = () => {
  const translate = useTranslate();
  const { activeWindow, closeWindow } = useMobileChrome();

  return (
    <MorphWindow
      open={activeWindow === "alerts"}
      onClose={closeWindow}
      trigger={morphTriggerSelector("alerts")}
      title={translate("crm.mobile.notifications")}
      closeLabel={translate("crm.mobile.close_notifications")}
      testId="mobile-alerts-window"
    >
      <p className="sr-only">{translate("crm.dashboard.latest_activity")}</p>
      <div className="rounded-[26px] bg-[var(--settings-card)] px-4 py-1 text-foreground">
        <ActivityLog pageSize={12} />
      </div>
    </MorphWindow>
  );
};
